// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"751":"59fa43f8","765":"b9a34c6d"}[chunkId] + ".chunk.js";
};